import React, { FunctionComponent, useEffect, useState } from 'react'
import styles from './BindDialog.module.sass'
import { Dialog } from '../../../../etc/Dialog/Dialog'
import Button from '../../../../controls/Button/Button'
import { Project, RelatedProject } from '../../../../../responses/projects'
import Label, { Display } from '../../../../controls/Label/Label'
import { createIdGenerator, isDefined, snoc } from '../../../../../utils/utils'
import { entityRemove, entityReplace } from '../../../../../utils/entity-utils'
import BindDropdown from './BindDropdown/BindDropdown'
import BindIcon from '../../../../../../files/bind.svg'
import OkCancel from '../../../../controls/OkCancel/OkCancel'
import { ID } from '../../../../../types/UtilityTypes'
import { AnimatePresence } from 'framer-motion'

interface Props {
    onClose?: () => void,
    onOk?: (project: Project) => void,
    project: Project,
}

interface Bind {
    id: ID,
    related?: RelatedProject,
}

const generator = createIdGenerator()

const BindDialog: FunctionComponent<Props> = props => {
    const [binds, setBinds] = useState<Bind[]>([])

    useEffect(() => setBinds(props.project.related?.map(related => ({
        id: generator.next().value,
        related,
    })) || []), [props.project])

    return <Dialog
        header={'Связать проекты'}
        onClose={props.onClose}
        className={styles.body}
        actions={({ onClose }) => <OkCancel
            onCancel={onClose}
            onOk={() => props.onOk?.({
                ...props.project,
                related: binds.map(bind => bind.related).filter(isDefined)
            })}
        />}
    >
        <div className={styles.group}>
            <Label display={Display.TOP} label={'Наименование текущего проекта'}>
                {props.project.name}
            </Label>
        </div>
        <AnimatePresence>
            {
                binds.map(bind => <BindDropdown
                    key={bind.id}
                    value={bind.related}
                    related={props.project.related || []}
                    projectId={props.project.id}
                    onChange={related => setBinds(entityReplace<Bind>({ id: bind.id, related }))}
                    onDelete={() => setBinds(entityRemove(bind))}
                />)
            }
        </AnimatePresence>
        <Button
            onClick={() => setBinds(snoc<Bind>({
                id: generator.next().value,
            }))}
        >
            <BindIcon/> Добавить связь
        </Button>
    </Dialog>
}

export default BindDialog